module.exports = __webpack_public_path__ + "img/IDEX_120X35.b8600808.png";